<template>
  <main>
    <Header />
    <div class="about">
      <Main />
      <Tiles />
    </div>
    <Footer />
    <FooterComponent />
  </main>
</template>

<script>
import Header from './Header.vue'
import Main from './Main.vue'
import Tiles from './Tiles.vue'
import Footer from './Footer.vue'
import FooterComponent from '../home/FooterComponent.vue'

export default {
  name: 'About',
  components: {
    Header,
    Main,
    Tiles,
    Footer,
    FooterComponent
  }
}
</script>



// WEBPACK FOOTER //
// src/app/about/About.vue